export default __webpack_public_path__ + "static/media/_dkg_brust-eierstockkrebs_rgb.1067e7ec.svg";